import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { sendGAPageview } from '../utils/gaConsent';
import $ from 'jquery';
import { Navigate, useSearchParams } from 'react-router-dom';
import Tools from '@/components/Tools/Tools';
import APIContent from '../components/API/APIContent';
import { useAuthStatus } from '@/store';

export default function Api() {
  const [searchParams] = useSearchParams();
  const { isAuthenticated, isAuthenticating } = useAuthStatus();

  const hasSection = searchParams.has('section');

  useEffect(() => {
    $('.popover').hide();
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      sendGAPageview({ hitType: 'pageview', page: '/Tools', title: 'Tools' });
    }
  }, [isAuthenticated]);

  if (isAuthenticating) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return (
    <>
      <Helmet>
        <title>DISGENET: Our API and database tools</title>
        <meta name="description" content="DISGENET offers different tools to access the database." />
        <meta property="og:title" content="DISGENET: Our API and database tools" />
        <meta
          property="og:description"
          content="Explore the various tools provided by DISGENET to access the database and enhance your research."
        />
        <meta property="og:url" content="https://www.disgenet.com/Tools" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/Tools" />
      </Helmet>
      {hasSection ? <APIContent /> : <Tools />}
    </>
  );
}
